import { parseIntegerField, type AlphaplanFormData } from './types.ts';

const blankToUndefined = (value: string): string | undefined => (value && value.trim() ? value : undefined);

/**
 * Map the form state onto the createAlphaplanIntegration / updateAlphaplanIntegration arguments.
 *
 * `apiKey`, `password` and `caBundle` are left out when the field is blank so an update never wipes the
 * stored secret: the backend only overwrites them when a non-blank value arrives. Channel lists are always
 * sent, so unticking every channel detaches them (`[]`), and `ocHeaderMemoField` is sent as '' to turn the
 * header memo off. `integrationParameters` is a graphene JSONString, so it goes over the wire JSON encoded.
 */
export const buildAlphaplanMutationVariables = (formData: AlphaplanFormData) => ({
    name: formData.name.trim(),
    baseUrl: formData.baseUrl.trim(),
    apiKey: blankToUndefined(formData.apiKey),
    username: formData.username.trim(),
    password: blankToUndefined(formData.password),
    proxy: formData.proxy.trim(),
    caBundle: blankToUndefined(formData.caBundle),
    supplierFilter: formData.supplierFilter.trim(),
    supplierNumberField: formData.supplierNumberField.trim(),
    purchaseOrderBelegType: parseIntegerField(formData.purchaseOrderBelegType) ?? undefined,
    openPoFilter: formData.openPoFilter.trim(),
    ocAbNumberField: formData.ocAbNumberField.trim(),
    ocWriteMode: formData.ocWriteMode,
    ocWriteOnConvertedPo: formData.ocWriteOnConvertedPo,
    ocPositionMemoField: formData.ocPositionMemoField.trim(),
    ocHeaderMemoField: formData.ocHeaderMemoField.trim(),
    ocToleranceBlock: formData.ocToleranceBlock,
    readMode: formData.readMode,
    attachSourceDocuments: formData.attachSourceDocuments,
    integrationParameters: JSON.stringify(formData.integrationParameters ?? {}),
    orderConfirmationChannels: formData.orderConfirmationChannelIds,
    invoiceChannels: formData.invoiceChannelIds,
});
